// extracted by mini-css-extract-plugin
export default {"article":"NotFound_article__FudTv","statusCode":"NotFound_statusCode__kIoyt","title":"NotFound_title__jcBXv"};